'use es6';

import http from 'hub-http/clients/apiClient';
export var startTrial = function startTrial(trialId, endDate, trialSource) {
  return http.post("/monetization-service/v2/trials/start?trialId=" + trialId + "&endDate=" + endDate + "&trialSource=" + trialSource).then(function () {
    return http.delete('/navconfig/v2/navconfig/cache');
  });
};